import { useApolloClient } from '@apollo/client';
import gql from 'graphql-tag';
import useErnie from 'shared/hooks/use-ernie';
import { ERNIE_DEFAULT_MESSAGES, ERNIE_TIMEOUTS, ERNIE_TYPES } from 'shared/constants';
import useInstoreCart from 'hooks/use-instore-cart';
import { useRouter } from 'next/compat/router';
import useDutchiePayEnrollment from 'hooks/use-dutchiePay-enrollment';
import { EnrollmentSteps } from 'src/payments/constants';
import { LoginSteps } from 'src/payments/state/instore-cart';

export const userExistsCheck = gql`
  query UserExistsCheck($input: userIdExistsInput!) {
    userExistsCheck(input: $input) {
      exists
      _id
    }
  }
`;

type UseUserExistsResult = {
  userExistsCheckQuery: ({ email }: { email: string }) => Promise<void>;
};

export const useUserExistsCheck = (): UseUserExistsResult => {
  const apolloClient = useApolloClient();
  const InstoreCart = useInstoreCart();
  const showErnie = useErnie();
  const router = useRouter();
  const DutchiePayEnrollment = useDutchiePayEnrollment();

  const userExistsCheckQuery = async ({ email }): Promise<void> => {
    try {
      const result = await apolloClient.query({
        query: userExistsCheck,
        variables: { input: { email } },
      });
      const { exists } = result.data.userExistsCheck;
      DutchiePayEnrollment.setExistingUser(exists);
      DutchiePayEnrollment.emailStepCompleted(email);
      if (!exists) {
        DutchiePayEnrollment.setCurrentStep(EnrollmentSteps.signUpForm);
        void router?.push({
          pathname: `/pay/signup`,
          query: { refUrl: `/pay/instore` },
        });
      } else {
        InstoreCart.setCurrentLoginStep(LoginSteps.PASSWORD);
      }
    } catch (err) {
      console.error(err);
      showErnie(ERNIE_DEFAULT_MESSAGES.ERROR, ERNIE_TYPES.DANGER, ERNIE_TIMEOUTS.LONG);
    }
  };

  return {
    userExistsCheckQuery,
  };
};
